/**
 * Sidebar — Vertical navigation matching the v2 mockup.
 * Mobile: off-canvas drawer (open / setOpen controlled).
 * Desktop: persistent sticky sidebar, collapsible to icon rail.
 */
import { NAV } from './nav';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export default function Sidebar({
  active,
  onNav,
  role,
  notificationCounts = {},
  collapsed,
  setCollapsed,
  open,
  setOpen,
}) {
  return (
    <>
      <div
        className={`scrim-nav${open ? ' show' : ''}`}
        onClick={() => setOpen(false)}
        data-testid="sidebar-scrim"
      />
      <aside
        className={`sidebar${collapsed ? ' collapsed' : ''}${open ? ' open' : ''}`}
        data-testid="lb-sidebar"
      >
        <div className="sidebar-head">
          <img src="/leadboard/kg-bubble.png" className="sidebar-logo" alt="KG" />
          <div className="sidebar-brand">
            <b>KGOB</b>
            <span>Admin Dashboard</span>
          </div>
        </div>

        <nav className="nav-scroll">
          {(NAV || []).map((sec, si) => {
            const items = (sec.items || []).filter((i) => i.role === 'any' || role === 'admin');
            if (!items.length) return null;
            return (
              <div className="nav-group" key={si}>
                {sec.group && <div className="nav-group-title">{sec.group}</div>}
                {(items || []).map((it) => {
                  const badge = it.badgeKey ? notificationCounts[it.badgeKey] : 0;
                  const Icon = it.Icon;
                  return (
                    <button
                      key={it.key}
                      data-testid={`nav-${it.key}`}
                      className={`nav-item${active === it.key ? ' active' : ''}`}
                      title={collapsed ? it.label : undefined}
                      onClick={() => {
                        onNav(it.key);
                        setOpen(false);
                      }}
                    >
                      <span className="nav-ico">
                        <Icon size={18} strokeWidth={2} />
                      </span>
                      <span className="nav-label">
                        {it.label}
                        {it.soon && (
                          <span
                            style={{
                              fontSize: 10,
                              fontWeight: 700,
                              marginLeft: 6,
                              color: 'var(--sidebar-fg-dim)',
                            }}
                          >
                            soon
                          </span>
                        )}
                      </span>
                      {badge > 0 && <span className="nav-badge">{badge}</span>}
                    </button>
                  );
                })}
              </div>
            );
          })}
        </nav>

        <div className="sidebar-foot">
          <button
            className="nav-item"
            data-testid="sidebar-collapse"
            onClick={() => setCollapsed(!collapsed)}
            title="Collapse"
          >
            <span className="nav-ico">
              {collapsed ? <ChevronRight size={17} /> : <ChevronLeft size={17} />}
            </span>
            <span className="nav-label sidebar-foot-text">Collapse</span>
          </button>
        </div>
      </aside>
    </>
  );
}
